import { useContext, useMemo } from "react";
import AuthContext from "../../context/authProvider";
import { renderGradeValueForTable } from "../utils/serialGradeFields";
import SimpleTable from "../table/SimpleTable";

const grade = (field) => (value, row) => renderGradeValueForTable(row, field, row?.product || row?.productData);

const SerialsList = ({ serials, setEdit, setEditableSerial }) => {
    const { user } = useContext(AuthContext);

    const columns = useMemo(() => [
        { key: "gradedAt", header: "Avaliado", width: 110, type: "date", filter: "date" },
        { key: "gradableModel.game", header: "Jogo", width: 120, filter: "list" },
        { key: "gradableModel.edition", header: "Edição", width: 140, filter: "list" },
        { key: "gradableModel.year", header: "Ano", width: 90, filter: "list" },
        { key: "gradableModel.name", header: "Nome", width: 180, filter: "text" },
        { key: "gradableModel.language", header: "Idioma", width: 110, visible: false, filter: "list" },
        { key: "gradableModel.numbering", header: "Numeração", width: 110, visible: false, filter: "text" },
        { key: "gradableModel.rarity", header: "Raridade", width: 110, visible: false, filter: "list" },
        { key: "serialNumber", header: "Serial", width: 120, filter: "text" },
        { key: "generalScore", header: "Nota Geral", width: 110, format: grade("generalScore") },
        { key: "notaAutografo", header: "Nota Autógrafo", width: 120, format: grade("notaAutografo") },
        { key: "centering", header: "Centering", width: 100, visible: false, format: grade("centering") },
        { key: "corners", header: "Corners", width: 100, visible: false, format: grade("corners") },
        { key: "edges", header: "Edges", width: 100, visible: false, format: grade("edges") },
        { key: "surface", header: "Surface", width: 100, visible: false, format: grade("surface") },
        {
            key: "acao", header: "Ação", width: 80, sortable: false, hideable: false, exportable: false,
            cell: ({ row }) => (
                <button type="button" onClick={() => { setEdit(true); setEditableSerial(row); }} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</button>
            ),
        },
    ], [setEdit, setEditableSerial]);

    return <SimpleTable tableKey="admin-serials" columns={columns} data={serials} exportable={user.roles.includes("master")} exportFileName="seriais" />;
};

export default SerialsList;
